// extracted by mini-css-extract-plugin
export var modal = "_ia-0";